import { useApplicationAccountsQuery } from './useApplicationAccountsQuery';
import { useApplicationAccountsSearch } from './useApplicationAccountsSearch';

export const useApplicationAccounts = (applicationId: string) => {

    if (typeof applicationId === 'undefined') {
        throw new Error('applicationId is required parameter');
    }

    const { data: items = [], isLoading: loading } = useApplicationAccountsQuery({ applicationId });
    const { keyword } = useApplicationAccountsSearch();

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter(item =>
        !keyword ||
        item.accountId?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.account?.username?.toLowerCase().includes(keyword.toLowerCase())
    );

    const visibleCount = visibleItems.length;

    return {
        items,
        visibleItems,
        visibleCount,
        loading,
    };
};
